module.exports = __webpack_public_path__ + "static/media/screenshot-4.6b64e412.png";